/**
 * Documentation related configuration
 */

export const LEGAL_DOCS_SOURCE = "/legal/";
export const GENERIC_DOCS_SOURCE = "/docs/";
export const TOC_YAML = "config/toc-docs.yaml";
export const LEGAL_VERSION = "v1.0.1";
export const GENERIC_DOCS_VERSION = "v1.0.1";

// Convenience method for relative retrieval of the protocol source files
export const documentFetch = (file, baseUrl) => fetch(`${baseUrl}${file}`);

// Convenience method for retrieving the TOC file
export const fetchTOC = (baseUrl, locale) => {
  const localePrefix = locale !== null ? `${locale}/` : "";
  return documentFetch(TOC_YAML, `${baseUrl}${localePrefix}`);
};

// Convert path component into an .md source file name
export const getPageFilename = (page) => {
  if (!page) {
    return null;
  }
  if (page.endsWith("/")) {
    page = page.slice(0, -1);
  }
  return `${page.replace("/", "-")}.md`;
};

export const simplifyLocale = (locale) => {
  // Simplify locale to just the language code (e.g. en-US to en)
  if (!locale) {
    return null;
  }
  if (!locale.includes("-")) {
    return locale;
  }
  const parts = locale.split("-");
  return parts[0];
};

// Convert path to a relative filename and retrieve its contents
export const fetchPageData = (page, baseUrl, locale = null) => {
  const pageFilename = getPageFilename(page);
  const localePrefix = locale !== null ? `${simplifyLocale(locale)}/` : "";
  return documentFetch(pageFilename, `${baseUrl}${localePrefix}`);
};
